<template>
  <div>
    <div class="right-box" v-if="isPC">
      <div class="filter f-b-c">
        <div></div>
        <div>
          <el-select v-model="listParams.countryCodeArray" collapse-tags :placeholder="$t('inSrock.shippingFrom')" @change="resetPage">
            <el-option v-for="item in shippingFromList" :key="item.countryCode" :label="item.countryCn" :value="item.countryCode"></el-option>
          </el-select>
          <Sort @change="sortChange" style="margin-left: 15px;"></Sort>
        </div>
      </div>
      <div v-loading="listLoading" class="f-b-c fw-w">
        <Product v-for="item in productList" :key="item.kkProductId" :product="item" :productInfoVisible="true" :style="{ width: $route.path === '/mall/new-in' ? '24%' : '19%' }"></Product>
        <div class="empty-product" />
        <div class="empty-product" />
        <div class="empty-product" />
      </div>
      <div class="f-e" style="padding-bottom:15px" v-show="productList.length>0">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="listParams.pageNumber" :page-sizes="[20, 40, 60,80, 100]" :page-size="listParams.pageSize" layout=" prev, pager, next,sizes" :total="total">
        </el-pagination>
      </div>
    </div>
    <div v-else>
      <div :class="[fixFilter?'fix-filter':'']">
        <van-dropdown-menu>
           <van-dropdown-item v-model="timeValue" :title="timeValue" :options="dateLineList" v-if="$route.path.indexOf('new-in')>-1" @change="value => timeChange(value)"></van-dropdown-item>
          <van-dropdown-item v-model="mobileShipFrom" title="Ship From">
            <van-cell center :title="item.countryCn" v-for="item in shippingFromList" :class="[item.checked?'checked-country':'']" :key="item.countryCn" @click="shipFromChangeMobile(item)">
              <template #right-icon>
                <i class="el-icon-check" v-if="item.checked"></i>
              </template>
            </van-cell>
          </van-dropdown-item>
          <van-dropdown-item :options="sortListForMobile" @change="value => sortChangeMobile(value)" v-model="sortKeyForMobile"></van-dropdown-item>
        </van-dropdown-menu>

      </div>
      <div class="product-list f-b-c fw-w " v-loading="listLoading">
        <Product v-for="item in productList" :key="item.kkProductId" :product="item" class="product-item"></Product>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
// import _ from 'lodash'
import { dateFormat } from '@/util/date'
import Sort from '@/views/commodity/components/Sort.vue'
// import FilterPopup from '@/components/mobile/FilterPopup.vue'
import Product from '@/components/Product.vue'
import DropdownMenu from 'vant/lib/dropdown-menu'
import 'vant/lib/dropdown-menu/style'
import DropdownItem from 'vant/lib/dropdown-item'
import 'vant/lib/dropdown-item/style'
import cell from 'vant/lib/cell'
import 'vant/lib/cell/style'
// import icon from 'vant/lib/icon'
import 'vant/lib/icon/style'
import getSortOptions from '@/config/sortOptions.js'
export default {

  props: {
    time: {
      type: String,
      default: ''
    },
    sortName: {
      type: String,
      default: '5'
    },
    attribute: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      listLoading: false,
      productList: [],
      listParams: {
        pageSize: 40,
        pageNumber: 1,
        categoryId: undefined,
        code: undefined, // 品类编码
        // materialArray: [], // 材质
        minPrice: undefined, // 区间最小售价
        maxPrice: undefined, // 区间最大售价
        minStock: undefined, // 最小库存
        maxStock: undefined, // 最大库存
        sortName: this.sortName, // 需要排序的字段
        sortType: 'desc', // 排序方式：desc ,asc
        searchName: undefined, // 产品名称
        countryCodeArray: undefined, // 发货国家编码
        timeLine: undefined // 时间
      },
      total: 0,
      timeValue: 'Daily New',
      shippingFromList: [],
      materialList: [],
      dateLine: [],
      filterVisible: false,
      filterState: '',
      fixFilter: false,
      mobileShipFrom: [],
      sortKeyForMobile: 1
    }
  },
  components: {
    Sort,
    Product,
    'van-dropdown-menu': DropdownMenu,
    'van-dropdown-item': DropdownItem,
    'van-cell': cell
    // 'van-icon': icon
  },
  computed: {
    sortListForMobile() {
      const arr = getSortOptions.call(this)
      arr.forEach(e => {
        e.text = e.name
        e.value = e.key
      })
      return arr
    },
    dateLineList() {
      const arr = this.dateLine
      this.dateLine.forEach((item, index) => {
        arr.forEach(x => {
          arr[index] = { text: item, value: item }
        })
      })
      return arr
    },
    userId() {
      return this.$store.state.common.userId
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.scroll)
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scroll)
  },
  created() {
    this.getMaterialList()
    this.getShippingFromList()
    this.$nextTick(() => {
      if (window.location.pathname.indexOf('index/sale') > -1) {
        this.getProductList()
      } else {
        this.getDateLine()
      }
    })
  },
  watch: {
    time(value) {
      this.listParams.timeLine = value
      this.listParams.pageNumber = 1
      this.getProductList()
    },
    attribute(value) {
      this.listParams.attribute = value
      this.listParams.pageNumber = 1
      this.getProductList()
    }
  },
  methods: {
    getDateLine() {
      API.getDateLine().then(res => {
        this.dateLine = res.data
        if (!this.isPC) {
          this.timeValue = this.dateLine[0]
          this.listParams.timeLine = this.dateLine[0]
          this.getProductList()
        }
      })
    },
    // 列表
    getProductList() {
      this.listLoading = true
      const listParams = { ...this.listParams, attribute: this.attribute }
      if (!this.isPC) { listParams.countryCodeArray = this.getCountryCodeArray() }
      if (this.isPC && listParams.countryCodeArray) listParams.countryCodeArray = [listParams.countryCodeArray]
      API.getProductList(listParams).then(result => {
        if (this.isPC) this.productList = result.data.list
        else this.productList = (+this.listParams.pageNumber === 1) ? result.data.list : [...this.productList, ...result.data.list]
        this.total = result.data.total
        if (this.isPC) {
          document.body.scrollTop = document.documentElement.scrollTop = 0
        }
      }).finally(() => {
        this.listLoading = false
      })
    },

    scroll() {
      if (this.isPC) {
        return
      }
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      if (scrollTop > (this.$route.path.includes('/sale') ? 115 : 50)) {
        this.fixFilter = true
      } else {
        this.fixFilter = false
      }
      if (scrollTop + windowHeight - scrollHeight > -200 && !this.listLoading && this.productList.length < this.total) {
        this.listParams.pageNumber++
        this.getProductList()
      }
    },

    priceChange(min, max) {
      this.listParams.minPrice = min
      this.listParams.maxPrice = max
      this.resetPage()
    },
    sortChange(sortName, sortType) {
      this.listParams.sortName = sortName
      this.listParams.sortType = sortType
      this.resetPage()
    },
    resetPage() {
      this.listParams.pageNumber = 1
      this.getProductList()
    },
    handleSizeChange(val) {
      this.listParams.pageSize = val
      this.getProductList()
    },
    handleCurrentChange(val) {
      if (!this.userId) {
        this.$router.push('/login')
        return
      }
      this.listParams.pageNumber = val
      this.getProductList()
    },
    getShippingFromList() {
      API.getShippingFromList({
        pageSize: 100,
        pageNumber: 1
      }).then(result => {
        // 以国家编码去重 且中国南中国北合并
        const map = {}
        result.data.list.forEach(item => {
          if (['CN_N', 'CN_S'].includes(item.countryCode)) {
            map['CN'] = {
              countryCn: 'China',
              countryCode: 'CN'
            }
            return
          }
          map[item.countryCode] = {
            countryCn: item.countryCn,
            countryCode: item.countryCode
          }
        })
        this.shippingFromList = Object.values(map)
      })
    },
    getMaterialList() {
      API.getMaterialList({
        categoryIds: this.listParams.categoryId
      }).then(result => {
        this.materialList = result.data
      })
    },
    getTime() {
      let date = new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 91)
      let dates = []
      for (let i = 1; i <= 90; i++) {
        dates.unshift(dateFormat(date + (3600 * 1000 * 24 * i), 'yyyy-MM-dd'))
      }
      return dates
    },
    getTimeValue(item, index) {
      this.activeIndex = index
      this.timeLine = item
    },

    timeChange(value) {
      this.listParams.timeLine = value
      this.timeValue = value
      this.productList = []
      this.resetPage()
    },
    shipFromChangeMobile(value) {
      this.$set(value, 'checked', !value.checked)
      this.resetPage()
    },
    getCountryCodeArray() {
      let countryCodeArray = this.shippingFromList.filter(e => e.checked).map(e => e.countryCode)
      return countryCodeArray.length ? countryCodeArray : undefined
    },
    sortChangeMobile(value) {
      const { sortName, sortType } = this.sortListForMobile.find(e => e.value === value)
      this.sortChange(sortName, sortType)
    }
  }

}
</script>

<style lang="scss" scoped>
.content {
  padding-left: 50px;
  padding-top: 33px;
}
.right-box {
  max-width: 1380px;
  .banner-head {
    padding-right: 16px;
    width: 100%;
    border-radius: 12px;
    margin-bottom: 30px;
    img {
      width: 100%;
      border-radius: 12px;
      object-fit: contain;
    }
  }
}
.filter-result {
  height: 78px;
}
.filter {
  padding: 10px 0;
  /deep/.el-select {
    margin-right: 13px;
  }
  /deep/.el-select__tags {
    flex-wrap: nowrap;
  }
  /deep/.el-select,
  /deep/.el-input__inner {
    width: 180px;
    height: 36px;
  }
}
.empty-product {
  width: 24%;
  height: 0;
}
.product-item {
  width: 48%;
  margin-bottom: 0.08rem;
}
.fix-filter{
  width: 100%;
  // height: 40px;
  background: #fff;
  position: fixed;
  top: 0.85rem;
  left: 0;
  z-index: 10;
  padding:0 0.3rem;
}
.product-list{
  margin-top: 0.2rem;
}
/deep/.van-dropdown-menu__bar{
  box-shadow: none;
}
/deep/.van-dropdown-item__option--active {
    color: #99C41C;
   background: rgba(153, 196, 28, 0.04);
}
/deep/.van-dropdown-item__icon{
  color: #99C41C;
}

/deep/.van-dropdown-menu__title--active {
   color: #99C41C;
}
/deep/.van-cell .van-cell--center{
  color: #99C41C;
}

/deep/.el-icon-check{
  color: #99C41C;
}
.checked-country{
  color: #99C41C;
   background: rgba(153, 196, 28, 0.04);
}
</style>
